import { render, staticRenderFns } from "./roles-listing.vue?vue&type=template&id=3e82bc3c&scoped=true&"
import script from "./roles-listing.vue?vue&type=script&lang=js&"
export * from "./roles-listing.vue?vue&type=script&lang=js&"
import style0 from "./roles-listing.vue?vue&type=style&index=0&id=3e82bc3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82bc3c",
  null
  
)

export default component.exports